import Box from "@mui/material/Box";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { NavLink } from "react-router-dom";
import styles from "./ReportsTree.module.css";
import { selectIsChatOpen } from "../../../redux/chat/selectors";
import { useSelector } from "react-redux";
import { FaTruck, FaUserFriends, FaWarehouse } from "react-icons/fa";
import clsx from "clsx";
import { GiTwoCoins, GiWallet } from "react-icons/gi";
import useTooltip from "../../../utils/useTooltip";
import Tooltip from "../../sharedComponents/Tooltip/Tooltip";

export default function ReportsTree({ hasAccess }) {
  const chatIsOpen = useSelector(selectIsChatOpen);

  const {
    tooltipPosition,
    isTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    tooltipText,
    handleClick,
  } = useTooltip();

  return (
    <Box
      className={clsx(styles.treeBox, { [styles.treeBoxOpenChat]: chatIsOpen })}
      sx={{
        minHeight: 0,
        width: chatIsOpen
          ? "clamp(28px, min(3.889vh, 2.27vw), 42px)"
          : "clamp(118px, min(9.189vw, 15.741vh), 170px)",
      }}
    >
      <SimpleTreeView>
        {hasAccess("/reports/profit") && (
          <TreeItem
            className={styles.treeItem}
            itemId="profit"
            onMouseEnter={e => handleMouseEnter(e, "Прибуток")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            label={
              <NavLink
                to="/reports/profit"
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.link
                }
              >
                {chatIsOpen ? (
                  <GiTwoCoins className={styles.icon} />
                ) : (
                  "Прибуток"
                )}
              </NavLink>
            }
          />
        )}
        <Tooltip
          isVisible={isTooltipVisible && chatIsOpen}
          position={tooltipPosition}
          text={tooltipText}
        />
        {hasAccess("/reports/balance") && (
          <TreeItem
            className={styles.treeItem}
            itemId="balance"
            onMouseEnter={e => handleMouseEnter(e, "Баланс")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            label={
              <NavLink
                to="/reports/balance"
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.link
                }
              >
                {chatIsOpen ? <GiWallet className={styles.icon} /> : "Баланс"}
              </NavLink>
            }
          />
        )}
        <Tooltip
          isVisible={isTooltipVisible && chatIsOpen}
          position={tooltipPosition}
          text={tooltipText}
        />
        {/* {hasAccess("/reports/clients") && (
          <TreeItem
            className={styles.treeItem}
            itemId="clients"
            onMouseEnter={e => handleMouseEnter(e, "Клієнти")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            label={
              <NavLink
                to="/reports/clients"
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.link
                }
              >
                {chatIsOpen ? (
                  <FaUserFriends className={styles.icon} />
                ) : (
                  "Клієнти"
                )}
              </NavLink>
            }
          />
        )}
        <Tooltip
          isVisible={isTooltipVisible && chatIsOpen}
          position={tooltipPosition}
          text={tooltipText}
        />
        {hasAccess("/reports/distributors") && (
          <TreeItem
            itemId="distributors"
            onMouseEnter={e => handleMouseEnter(e, "Постачальники")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            label={
              <NavLink
                to="/reports/distributors"
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.link
                }
              >
                {chatIsOpen ? (
                  <FaTruck className={styles.icon} />
                ) : (
                  "Постачальники"
                )}
              </NavLink>
            }
          />
        )}
        <Tooltip
          isVisible={isTooltipVisible && chatIsOpen}
          position={tooltipPosition}
          text={tooltipText}
        />
        {hasAccess("/reports/warehouse") && (
          <TreeItem
            className={styles.treeItem}
            itemId="warehouse"
            onMouseEnter={e => handleMouseEnter(e, "Склад")}
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            onClick={handleClick}
            label={
              <NavLink
                to="/reports/warehouse"
                className={({ isActive }) =>
                  isActive ? styles.activeLink : styles.link
                }
              >
                {chatIsOpen ? <FaWarehouse className={styles.icon} /> : "Склад"}
              </NavLink>
            }
          />
        )}
        <Tooltip
          isVisible={isTooltipVisible && chatIsOpen}
          position={tooltipPosition}
          text={tooltipText}
        /> */}
      </SimpleTreeView>
    </Box>
  );
}
